import {
	type VoiceDictationResult,
	VoiceDictationState,
	type WebSpeechToTextAPIAction,
} from './speech-to-text/WebSpeechToTextModels';

export const voiceDictationReducer = (
	result: VoiceDictationResult,
	action: WebSpeechToTextAPIAction,
): VoiceDictationResult => {
	switch (action.type) {
		case 'SET_INITIALIZING':
			return {
				state: VoiceDictationState.Initializing,
				transcription: null,
			};
		case 'SET_RECORDING':
			return {
				state: VoiceDictationState.Recording,
				transcription: action.payload.transcription,
				chunkIndex: action.payload.chunkIndex,
			};
		case 'SET_STOPPED':
			return {
				...result,
				state: VoiceDictationState.Stopped,
				stopReason: action.payload.stopReason,
			};
		case 'SET_ERROR':
			return {
				...result,
				state: VoiceDictationState.Error,
				error: action.payload.error,
			};
		default:
			return result;
	}
};
